import { createSlice } from "@reduxjs/toolkit";
import {
  fetchTemplate,
  updateTemplate,
  updateTemplateStatus,
  deleteTemplateById,
  fetchTemplateById,
  updateTemplateWithLatestItems,
} from "./thunk";

interface TemplateState {
  templateList: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
  selectedTemplate: any;
}

const initialState: TemplateState = {
  templateList: [],
  rowCount: 0,
  loading: false,
  error: null,
  selectedTemplate: null,
};

const TemplateSlice = createSlice({
  name: "template",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Fetch All Templates
      .addCase(fetchTemplate.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTemplate.fulfilled, (state, action) => {
        state.loading = false;
        state.templateList = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchTemplate.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch GPs";
      })


      // Fetch Template by ID
      .addCase(fetchTemplateById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTemplateById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedTemplate = action.payload;
      })
      .addCase(fetchTemplateById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Update Template
      .addCase(updateTemplate.fulfilled, (state, action) => {
        if (!action.payload?.template_id) return;
        state.templateList = state.templateList.map((temp) =>
          temp.template_id === action.payload.template_id ? action.payload : temp
        );
      })
      .addCase(updateTemplate.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update Template";
      })

      // Update Template Status By ID
      .addCase(updateTemplateStatus.fulfilled, (state, action) => {
        // Prefer explicit payload with identifiers; fallback to toggling by arg id
        const payload: any = action.payload || {};
        const targetId = payload.template_id || payload.id || action.meta.arg;
        if (!targetId) return;

        state.templateList = state.templateList.map((temp: any) => {
          if (temp.template_id === targetId || temp.id === targetId) {
            const nextStatus =
              payload.status !== undefined ? payload.status : !temp.status;
            return { ...temp, status: nextStatus };
          }
          return temp;
        });
      })
      .addCase(updateTemplateStatus.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update Template Status";
      })

      
      // Delete Template By ID
      .addCase(deleteTemplateById.fulfilled, (state, action) => {
        state.loading = false;
        const deletedId = action.payload?.id;
        if (deletedId) {
          state.templateList = state.templateList.filter((temp) => temp.template_id !== deletedId);
        }
      })
      .addCase(deleteTemplateById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })


      // Update selected template with latest items 
      .addCase(updateTemplateWithLatestItems.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateTemplateWithLatestItems.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedTemplate = action.payload;
      })
      .addCase(updateTemplateWithLatestItems.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })


  },
});

export default TemplateSlice.reducer;
